import React from 'react'
import { Box, Button, Divider, Typography } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { userInfoState } from '../../recoil/atoms'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import HomeIcon from '@material-ui/icons/Home'
import InfoIcon from '@material-ui/icons/Info'
import MailIcon from '@material-ui/icons/Mail'
import WorkIcon from '@material-ui/icons/Work'
import PaymentIcon from '@material-ui/icons/Payment'
import BusinessIcon from '@material-ui/icons/Business'
import SmsIcon from '@material-ui/icons/Sms'
import PeopleIcon from '@material-ui/icons/People'
import StarIcon from '@material-ui/icons/Star'
import SettingsIcon from '@material-ui/icons/Settings'
import PersonIcon from '@material-ui/icons/Person'
import SwapHorizIcon from '@material-ui/icons/SwapHoriz'
import ContactMailIcon from '@material-ui/icons/ContactMail'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import WarningIcon from '@material-ui/icons/Warning'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import arjanRing from '../../assets/pic/arjan_ring.jpg'

// آیتمهای منو — ادمین: ترتیب درخواستی (بدون مدیریت کاربر و تماس با ما)؛ سایر نقشها مانند قبل
const buildItems = (userInfo, editProfile, firstTimeLogin, onSwitchRole, onContact) => {
  if (userInfo.role === 'Admin') {
    return [
      { to: '/', text: 'داشبورد', icon: <HomeIcon fontSize="small" /> },
      { to: '/organizations', text: 'سازمان‌ها', icon: <BusinessIcon fontSize="small" /> },
      { to: '/users', text: 'کاربران', icon: <PeopleIcon fontSize="small" /> },
      { to: '/auth-review', text: 'حساب‌های نیازمند بررسی', icon: <WarningIcon fontSize="small" /> },
      { to: '/billing', text: 'مالی و اشتراک‌ها', icon: <PaymentIcon fontSize="small" /> },
      { to: '/contractor-stats', text: 'حوالهٔ پیمانکارانِ بی‌مشترک', icon: <TrendingUpIcon fontSize="small" /> },
      { to: '/sms-logs', text: 'تاریخچه پیامک‌ها', icon: <SmsIcon fontSize="small" /> },
      { to: '/settings', text: 'تنظیمات', icon: <SettingsIcon fontSize="small" /> },
      { to: '/messages', text: 'پیام‌ها', icon: <MailIcon fontSize="small" />, dot: !!userInfo.new_message },
      { to: '/help', text: 'راهنما', icon: <HelpOutlineIcon fontSize="small" /> },
      { to: '/about', text: 'درباره ما', icon: <InfoIcon fontSize="small" /> },
    ]
  }

  const items = [
    { to: '/', text: 'داشبورد', icon: <HomeIcon fontSize="small" /> },
    { to: '/about', text: 'درباره ما', icon: <InfoIcon fontSize="small" /> },
  ]
  // «مدیر سازمان» همهٔ پیمانکاران را در خودِ داشبورد دارد ⇒ منوی جدا لازم نیست
  if (userInfo.role === 'Department') {
    items.push({ to: '/contractors', text: 'پیمانکاران', icon: <WorkIcon fontSize="small" /> })
  }
  items.push({ to: editProfile, text: 'مدیریت کاربر', icon: <PersonIcon fontSize="small" /> })
  if (onSwitchRole) {
    items.push({ action: onSwitchRole, text: 'تغییر نقش', icon: <SwapHorizIcon fontSize="small" /> })
  }
  // انتهای لیست
  items.push({ to: '/messages', text: 'پیام‌ها', icon: <MailIcon fontSize="small" />, dot: !!userInfo.new_message })
  items.push({ to: '/help', text: 'راهنما', icon: <HelpOutlineIcon fontSize="small" /> })
  if (onContact) {
    items.push({ action: onContact, text: 'تماس با ما', icon: <ContactMailIcon fontSize="small" /> })
  }
  return items
}

/**
 * سایدبار راست — برای همهٔ نقشها (دسکتاپ ثابت / موبایل داخل Drawer)
 * props: logout, editProfile, firstTimeLogin, onSwitchRole, onClose (در حالت Drawer)
 */
const Sidebar = (props) => {
  const location = useLocation()
  const userInfo = useRecoilValue(userInfoState)
  const items = buildItems(userInfo, props.editProfile, props.firstTimeLogin, props.onSwitchRole, props.onContact)

  const itemBase = {
    display: 'flex',
    justifyContent: 'flex-start',
    width: 'calc(100% - 20px)',
    margin: '3px 10px',
    padding: '9px 12px',
    borderRadius: 10,
    textTransform: 'none',
    fontSize: 13.5,
    color: 'rgba(255,255,255,.86)',
    gap: 10,
  }

  const handleNav = () => {
    if (props.onClose) props.onClose()
  }

  return (
    <Box
      component="nav"
      style={{
        width: 236,
        minWidth: 236,
        height: '100vh',
        position: 'sticky',
        top: 0,
        background: 'linear-gradient(175deg, #101a4d 0%, #1a237e 60%, #2b2f8f 100%)',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        zIndex: 1100,
      }}
    >
      {/* برند */}
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '18px 16px 14px',
          borderBottom: '1px solid rgba(255,255,255,.12)',
        }}
      >
        <img
          src={arjanRing}
          alt="ارجان"
          style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', border: '1.5px solid rgba(255,215,120,.6)' }}
        />
        <Box>
          <Typography style={{ color: '#fff', fontWeight: 800, fontSize: 14.5, lineHeight: 1.3 }}>
            سامانه ارجان پیمان
          </Typography>
          <Typography style={{ color: 'rgba(255,255,255,.55)', fontSize: 10.5 }}>
            {userInfo.role === 'Admin' ? 'مدیریت'
              : userInfo.role === 'Department' ? 'سازمان'
              : userInfo.role === 'DepartmentManager' ? 'مدیر سازمان'
              : 'کاربر'}
          </Typography>
        </Box>
        {props.onClose && (
          <Button onClick={props.onClose} style={{ color: '#fff', marginRight: 'auto', padding: 4 }}>
            <MenuOpenIcon />
          </Button>
        )}
      </Box>

      {/* آیتمها */}
      <Box style={{ flex: 1, paddingTop: 8 }}>
        {items.map((it, idx) => {
          const active = it.to && location.pathname === it.to
          const disabled = !!props.firstTimeLogin && !it.to?.includes(props.editProfile)
          if (it.to) {
            return (
              <Button
                key={idx}
                component={Link}
                to={it.to}
                onClick={handleNav}
                disabled={disabled}
                startIcon={it.icon}
                style={{
                  ...itemBase,
                  background: active ? 'rgba(255,255,255,.16)' : 'transparent',
                  color: active ? '#fff' : 'rgba(255,255,255,.86)',
                  fontWeight: active ? 700 : 400,
                  borderLeft: active ? '3px solid #ffd54f' : '3px solid transparent',
                  justifyContent: 'flex-start',
                }}
              >
                {it.text}
                {it.dot && (
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ff5252', marginRight: 6 }} />
                )}
              </Button>
            )
          }
          return (
            <Button
              key={idx}
              onClick={() => {
                it.action()
                handleNav()
              }}
              disabled={disabled}
              startIcon={it.icon}
              style={{ ...itemBase, justifyContent: 'flex-start' }}
            >
              {it.text}
            </Button>
          )
        })}
      </Box>

      <Divider style={{ background: 'rgba(255,255,255,.12)', margin: '8px 0' }} />

      {/* خروج */}
      <Button
        onClick={props.logout}
        startIcon={<ExitToAppIcon fontSize="small" />}
        style={{
          ...itemBase,
          color: '#ff8a80',
          marginBottom: 12,
          justifyContent: 'flex-start',
        }}
      >
        خروج
      </Button>
    </Box>
  )
}

export default Sidebar
